import React from 'react';
import { Grid, Box } from '@material-ui/core';

import BaseTopBar from 'components/elements/molecules/TopBar';
import ButtonGoBack from 'components/elements/atoms/ButtonGoBack';
import Place from './components/Place';
import useCars from '../../context/useCars';
import { useTranslations } from 'components/utilities';
import { StickyBar } from './components/StickyBar';

const TopBar = () => {
	const { airport } = useCars();

	const {
		t,
		i18n: { language },
	} = useTranslations();

	return (
		<BaseTopBar
			title={t('cars.header')}
			actions={
				<Grid container justify="space-between" alignItems="center">
					<Grid item xs="auto">
						<Box pl={1}>
							<ButtonGoBack />
						</Box>
					</Grid>
					<Grid item xs="auto">
						<Place title={airport.city[language]} />
					</Grid>
				</Grid>
			}
			stickyBar={<StickyBar />}
		/>
	);
};

export default TopBar;
